<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroAconexRegister" />
    <Section :content="studyAcceleratorFaster" />
    <Section :content="easyToUse" />
    <Section :content="approveReview" />
    <Section :content="upToAconex" />
    <call-to-action-aconex-register />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
export default {
  name: 'AconexRegister',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter,
    CallToActionAconexRegister
  },
  data() {
    return { 
      heroAconexRegister: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: 'Aconex Accelerator',
        header: 'Register to Aconex up to 100+ times faster',
        subheader: 'Construction projects generate a constant flow of documents and revisions that need to be registered with multiple fields of information to Aconex.',
        img: '',
        videoId: '945901280',
        buttons: [
          { label: '100+ times Faster', path: '', id: 'study-accelerator-faster' },
          { label: 'Easy to Use', path: '', id: 'easy-to-use' },
          { label: 'Approve Review', path: '', id: 'approve-review'},
          { label: 'Up To Aconex', path: '', id: 'up-to-aconex'},
        ]
      },
      studyAcceleratorFaster: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Study shows Aconex Accelerator 100+ times faster ',
        paragraphs: [
          'A study conducted to register a large set of construction drawings took 25.5 hours of manual work vs 22 minutes with the Aconex Accelerator.',
          '\u002aThe study used drawing sets from five actual construction projects: car dealership (88), stadium expansion (177), mixed-use office (428), mixed-use highrise (962), data center (1622),Total: 3277 sheets'
        ],
        id: 'study-accelerator-faster',
        image: 'manual-registration-vs-aconex-accelerator.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      easyToUse: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Easy to Use',
        paragraphs: [
          'Simply click the start button to begin crosslinking the sheets or sections. When you receive the confirmation email, click the Review button to view and edit the results.'
        ],
        id: 'easy-to-use',
        image: 'start-review-accept.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      approveReview: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Approve Review',
        paragraphs: [
          'The Aconex Accelerator will automatically split up the sheets or sections, and then find and fill in all the required information for you, and show you where it found the information on each sheet or section.',
          'The review app then allows you to edit the information prior to uploading to Aconex. When you are satisfied with the results, click the Accept and Save button.'
        ],
        id: 'approve-review',
        image: 'review-specs-and-drawings.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      upToAconex: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Up to Aconex',
        paragraphs: [
          'All of the individual sheets or sections, with the required information, gets registered to Aconex automatically.'
        ],
        id: 'up-to-aconex',
        image: 'auto-uploaded-to-aconex.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      aconexRegisterCTA: {
        header: 'Try It Now',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
